import { siteMetadata } from "../../gatsby-config";

async function recaptchaSubmit(executeRecaptcha, action) {
  if (typeof executeRecaptcha !== `function`) return false;

  const token = await executeRecaptcha("submit");
  // --> validate result, and then handle submit
  let url = siteMetadata.drupalUrl + "/recaptcha/verify/" + token;

  if (action) {
    url = url + "?recaptcha_action=" + action;
  }

  const result = await fetch(url, {
    method: "GET",
    mode: "cors",
    headers: { "Content-type": "application/json" },
  });

  const responseData = await result.json();
  let validation;
  if (responseData.data) {
    validation = JSON.parse(responseData.data);
  }
  console.log("Recaptcha validation", validation);
  if (
    validation &&
    validation.verification &&
    validation.verification.success &&
    validation.verification.score >= 0.5
  ) {
    if (validation.verification.test)
      console.log("recaptcha test mode enabled");
    return true;
  }
  return false;
}
export default recaptchaSubmit;
